import React, { CSSProperties } from 'react'

type Presentation = {
  logoOverlay?: boolean
  logoEmbedded?: boolean
  logoSrc?: string
  logoAlt?: string
}

export const hasBrandLogoOverlay = (presentation?: Presentation, fallbackLogoSrc?: string): boolean =>
  presentation?.logoOverlay === true && presentation.logoEmbedded !== true
  && Boolean(presentation.logoSrc || fallbackLogoSrc)

const badgeStyle: CSSProperties = {
  position: 'absolute', top: 'clamp(12px, 2vw, 24px)', left: 'clamp(12px, 2vw, 24px)',
  width: 'clamp(100px, 18vw, 176px)', height: 'clamp(56px, 8vw, 88px)',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  padding: 'clamp(10px, 1.5vw, 18px)', boxSizing: 'border-box',
  borderRadius: 12, backgroundColor: 'rgba(255, 255, 255, .94)',
  boxShadow: '0 3px 14px rgba(16, 45, 89, .08)', pointerEvents: 'none', zIndex: 1,
}

/** Opt-in presentation: retain the authentic manufacturer mark on its scene. */
const BrandLogoOverlay: React.FC<{
  presentation?: Presentation
  fallbackLogoSrc?: string
  fallbackAlt?: string
}> = ({ presentation, fallbackLogoSrc, fallbackAlt }) => {
  if (!hasBrandLogoOverlay(presentation, fallbackLogoSrc)) return null
  return <span data-brand-logo-overlay='true' style={badgeStyle}>
    <img
      src={presentation?.logoSrc || fallbackLogoSrc}
      alt={presentation?.logoAlt || fallbackAlt || 'Herstellerlogo'}
      style={{ display: 'block', width: '100%', height: '100%', objectFit: 'contain' }}
      decoding='async'
    />
  </span>
}

export default BrandLogoOverlay
